// extracted by mini-css-extract-plugin
module.exports = {"BulkEditModalButtonWrapper":"styles_BulkEditModalButtonWrapper__j56XW","BulkEditModalTextArea":"styles_BulkEditModalTextArea__XCMFH"};